var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSgp = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1474_26232)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 12C0 5.37263 5.37262 0 12 0C18.6274 0 24 5.37263 24 12",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.30353 6.26052C7.30353 4.51218 8.53227 3.05165 10.1731 2.69329C9.92089 2.63826 9.65928 2.6084 9.39045 2.6084C7.37338 2.6084 5.73828 4.24349 5.73828 6.26057C5.73828 8.27765 7.37338 9.91274 9.39045 9.91274C9.65919 9.91274 9.92084 9.88288 10.1731 9.82781C8.53227 9.46945 7.30353 8.00891 7.30353 6.26052V6.26052Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9995 2.86914L12.2585 3.66625H13.0967L12.4186 4.15895L12.6776 4.95606L11.9995 4.46345L11.3214 4.95606L11.5804 4.15895L10.9023 3.66625H11.7405L11.9995 2.86914Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.96639 4.43457L10.2254 5.23173H11.0635L10.3855 5.72438L10.6445 6.52149L9.96639 6.02888L9.2882 6.52149L9.54728 5.72438L8.86914 5.23173H9.70731L9.96639 4.43457Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.0327 4.43457L14.2918 5.23173H15.1299L14.4518 5.72438L14.7108 6.52149L14.0327 6.02888L13.3546 6.52149L13.6136 5.72438L12.9355 5.23173H13.7737L14.0327 4.43457Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.2495 6.78223L13.5085 7.57938H14.3467L13.6686 8.07204L13.9276 8.86915L13.2495 8.37654L12.5714 8.86915L12.8304 8.07204L12.1523 7.57938H12.9904L13.2495 6.78223Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.7476 6.78223L11.0066 7.57938H11.8448L11.1667 8.07204L11.4257 8.86915L10.7476 8.37654L10.0695 8.86915L10.3285 8.07204L9.65039 7.57938H10.4886L10.7476 6.78223Z",
  fill: "#F0F0F0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1474_26232"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSgp);
export { ForwardRef as ReactComponent };